var map = {
	"./home_tooltips_football_ch.png": 38763,
	"./home_tooltips_football_en.png": 42711,
	"./home_tooltips_marksix_ch.png": 64315,
	"./home_tooltips_marksix_en.png": 86663,
	"./home_tooltips_racing_ch.png": 91328,
	"./home_tooltips_racing_en.png": 97632
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24227;